import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowPathOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M11.625 12c-.293.711-.681 1.3-1.168 1.733-.601.533-1.392.867-2.457.867-1.594 0-2.626-.75-3.298-1.928s-.98-2.787-1-4.48L5.01 9.5 6 8.51l-3-3-3 3 .99.99L2.301 8.19c.021 1.828.348 3.71 1.185 5.177C4.376 14.926 5.844 16 8 16c1.389 0 2.516-.447 3.386-1.22.819-.728 1.373-1.709 1.732-2.78z"
                    fill="currentColor"
                />
                <path
                    d="m13 10.49-3-3 .99-.99L12.3 7.81c-.021-1.694-.33-3.304-1-4.48C10.626 2.15 9.594 1.4 8 1.4c-1.115 0-1.933.366-2.546.95-.446.425-.804.984-1.078 1.65H2.883c.34-1.017.856-1.95 1.605-2.664C5.373.494 6.54 0 8 0c2.156 0 3.624 1.075 4.514 2.634.837 1.467 1.164 3.35 1.185 5.177l1.311-1.31.99.989z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ArrowPathOutlinedSize16Glyph.displayName = 'ArrowPathOutlinedSize16Glyph';
